export default "__VITE_ASSET__yNcLgN12__"